import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import TowGuidePage from "@/pages/TowGuidePage";

export const Route = createFileRoute("/tow-guides")({
  head: () => pageHead({
    title: 'RV Tow Guides',
    description: 'Find towing capacities and towable RV matches with Rex & Sons RVs tow guides — match your truck or SUV to the right camper.',
    path: '/tow-guides',
  }),
  component: TowGuidePage,
});
